export const SET_LOADING_DATA = '@productPhotos/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@productPhotos/SET_LOADING_SELECTS';
export const SET_LOADING_SEND = '@productPhotos/SET_LOADING_SEND';
export const SET_LOADING_MODAL = '@productPhotos/SET_LOADING_MODAL';

export const GET_ALL_REQUEST = '@productPhotos/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@productPhotos/GET_ALL_SUCCESS';

export const GET_FILTER_SELECTS_REQUEST = '@productPhotos/GET_FILTER_SELECTS_REQUEST';
export const GET_FILTER_SELECTS_SUCCESS = '@productPhotos/GET_FILTER_SELECTS_SUCCESS';

export const GET_BY_ID_REQUEST = '@productPhotos/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@productPhotos/GET_BY_ID_SUCCESS';

export const SET_PAGE = '@productPhotos/SET_PAGE';
export const SET_ROWS_COUNT = '@productPhotos/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@productPhotos/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@productPhotos/SET_ORDER';
export const SET_ORDERBY = '@productPhotos/SET_ORDERBY';

export const SEARCH = '@productPhotos/SEARCH';

// FORM

export const EDIT_ITEM = '@productPhotos/EDIT_ITEM';

export const SAVE_REQUEST = '@productPhotos/SAVE_REQUEST';
export const SAVE_SUCCESS = '@productPhotos/SAVE_SUCCESS';

export const GET_FILTER_PRODUCT_REQUEST = '@productPhotos/GET_FILTER_PRODUCT_REQUEST';
export const GET_FILTER_PRODUCT_SUCCESS = '@productPhotos/GET_FILTER_PRODUCT_SUCCESS';

export const GET_ALL_PRODUCTS_URLS_REQUESTS = '@productPhotos/GET_ALL_PRODUCTS_URLS_REQUESTS';
export const GET_ALL_PRODUCTS_URLS_SUCCESS = '@productPhotos/GET_ALL_PRODUCTS_URLS_SUCCESS';

export const DELETE_ITEMS = '@productPhotos/DELETE_ITEMS';
